import { ITransaction } from "@/models/transaction/transaction.types"
import { ITransactionDetails } from "@/models/transactionDetails/transactionDetails.types"

import { TransactionParser } from "@/models/transaction/transaction.parser"

import { TransactionDetailsParser } from "@/models/transactionDetails/transactionDetails.parser"

import { QueryResult } from "@/api/utils/types"
import { useQuery } from "@/api/utils/useQuery"
import { BackofficeRestQueries } from "@/api/backofficeRest/queries"
import { HasuraQueries } from "@/api/hasura/queries"
import { AccountTransaction } from "@/api/backofficeRest/generated/model"
import { GetAccountCreditQuery } from "@/api/hasura/generated/graphql"

export interface ITransactionService {
  getForAccount(billingAccountId: number | null): QueryResult<ITransaction[]>
  getAccountCreditDetails(
    accountCreditId: string,
  ): QueryResult<ITransactionDetails | null>
}

class TransactionServiceClass implements ITransactionService {
  getForAccount(billingAccountId: number | null): QueryResult<ITransaction[]> {
    return useQuery({
      ...BackofficeRestQueries.billing.transactions(billingAccountId ?? 0),
      placeholderData: [],
      useRawResponse: true,
      enabled: !!billingAccountId,
      parserFn: (rawData: AccountTransaction[]) =>
        (rawData ?? []).map((rawTransaction) =>
          TransactionParser.toDomain(rawTransaction),
        ),
    })
  }
  getAccountCreditDetails(accountCreditId: string) {
    return useQuery({
      ...HasuraQueries.account.accountCredit(accountCreditId),
      useRawResponse: true,
      parserFn: (rawData: GetAccountCreditQuery) => {
        const accountCreditRaw = rawData?.account_credit[0]
        return accountCreditRaw
          ? TransactionDetailsParser.toDomain(accountCreditRaw)
          : null
      },
    })
  }
}

export const TransactionService = new TransactionServiceClass()
